import { createRouter, createWebHistory } from "vue-router";
import Lists from "../views/Lists.vue";
import List from "../views/List";
import Order from "../views/Order.vue";
import Items from "../views/Items.vue";
import Item from "../views/Item.vue";
import Login from "../views/Login";
import SignUp from "../views/SignUp";
import Invite from "../views/Invite.vue";
import Forbidden from "../views/Forbidden.vue";
import NotFound from "../views/NotFound.vue";
import Predictions from "../views/Predictions";
import NProgress from "nprogress";
import store from "../store";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Lists,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/lists",
    name: "Lists",
    component: Lists,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/lists/:id",
    name: "List",
    component: List,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/lists/:id/order",
    name: "Order",
    component: Order,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/items",
    name: "Items",
    component: Items,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/items/:id",
    name: "Item",
    component: Item,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/invites/:token",
    name: "Invite",
    component: Invite,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/signup",
    name: "Sign Up",
    component: SignUp,
  },
  {
    path: "/passwordReset",
    name: "Password Reset",
    redirect: "/login",
  },
  {
    path: "/verify",
    name: "Verify Email Address",
    redirect: "/login",
  },
  {
    path: "/predictions",
    name: "Predictions",
    component: Predictions,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/forbidden",
    name: "Forbidden",
    component: Forbidden,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/not-found",
    name: "Missing Resource",
    component: NotFound,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Not Found",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  var loggedIn = store.getters["loggedIn"];

  if (to.name) {
    NProgress.start();
  }

  if (to.matched.some((record) => record.meta.requiresAuth && !loggedIn)) {
    return next({ name: "Login", query: { redirect: to.fullPath } });
  }

  return next();
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
